import { render } from "./AdAccountSpendCapModalContent.vue?vue&type=template&id=27ba423a"
import script from "./AdAccountSpendCapModalContent.vue?vue&type=script&lang=js"
export * from "./AdAccountSpendCapModalContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/AdAccountSpendCapModalContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27ba423a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27ba423a', __exports__)) {
    api.reload('27ba423a', __exports__)
  }
  
  module.hot.accept("./AdAccountSpendCapModalContent.vue?vue&type=template&id=27ba423a", () => {
    api.rerender('27ba423a', render)
  })

}


export default __exports__